import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';

import { updateEntities } from '../utils';
import { ActiveVehicle } from '../../core/models';
import { SetActiveVehiclesAction, UpdateActiveVehicleAfterUpdatingItsInfoAction } from './active-vehicle.actions';

export interface ActiveVehicleStateModel {
  entities: { [key: number]: ActiveVehicle };
  ids: number[];
}

@State<ActiveVehicleStateModel>({
  name: 'activeVehicle',
  defaults: {
    entities: {},
    ids: [],
  },
})
@Injectable()
export class ActiveVehicleState {

  @Action(SetActiveVehiclesAction)
  setActiveVehicles(
    ctx: StateContext<ActiveVehicleStateModel>,
    action: SetActiveVehiclesAction,
  ) {
    const stateUpdate = updateEntities(action.payload, ActiveVehicle);
    ctx.patchState(stateUpdate);
  }

  @Action(UpdateActiveVehicleAfterUpdatingItsInfoAction)
  updateActiveVehicleAfterUpdatingItsInfo(
    ctx: StateContext<ActiveVehicleStateModel>,
    action: UpdateActiveVehicleAfterUpdatingItsInfoAction,
  ) {
    const vehicleId = action.payload.id;
    const { entities } = ctx.getState();

    ctx.patchState({
      entities: {
        ...entities,
        [vehicleId]: {
          ...entities[vehicleId],
          ...action.payload,
        },
      },
    });
  }
}
